import styled from "styled-components";

const ChangeStatusWrapper = styled.div`
	padding: 14px 16px;
`;

const ButtonStyled = styled.button`
	background-color: unset;
	outline: none;
	border: none;
	cursor: pointer;
`;

export { ChangeStatusWrapper, ButtonStyled };
